import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';

interface FlagAssetModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (reason: string) => void;
  assetName: string;
}

export function FlagAssetModal({
  open,
  onOpenChange,
  onConfirm,
  assetName,
}: FlagAssetModalProps) {
  const [reason, setReason] = useState('Flagged for review');

  const handleConfirm = () => {
    onConfirm(reason);
    setReason('Flagged for review'); // Reset for next time
    onOpenChange(false);
  };

  const handleCancel = () => {
    setReason('Flagged for review'); // Reset
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Flag Asset for Review</DialogTitle>
          <DialogDescription>
            You are flagging <strong>{assetName}</strong> for review. Please provide a reason below.
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="reason">Reason for Flagging</Label>
            <Textarea
              id="reason"
              placeholder="Enter reason for flagging this asset..."
              value={reason}
              onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setReason(e.target.value)}
              rows={4}
              className="resize-none"
            />
            <p className="text-sm text-muted-foreground">
              This will be added to the asset history with your name and timestamp.
            </p>
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={handleCancel}>
            Cancel
          </Button>
          <Button onClick={handleConfirm} disabled={!reason.trim()}>
            Flag Asset
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
